/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
/** Common Components */
import Buttons from "../../../../components/ui/button/Buttons";
import { AppIcons } from "../../../../data/appIcons";
/** RTK Query */
import {
  useLazyGetProjectComponentByIdQuery,
  useUpdateProjectComponentMutation,
} from "../../../../app/services/projectComponentAPI";
/** Common Services & Data Files */
import ToastService from "../../../../services/toastService/ToastService";
import {
  decryptUrlData,
  encryptUrlData,
} from "../../../../services/CryptoService";
import ProjectModuel from "./features/ProjectModule";
import CardSection from "../../../../components/ui/card/CardSection";
import projectComponentsFormData from "./config/ProjectComponent.data";
import FormCreator from "../../../../components/finalForms/FormCreator";

const EditProjectComponent = () => {
  const ref = useRef();
  /* State*/
  const [formData, setFormData] = useState(projectComponentsFormData);
  const { id } = useParams();
  const componetData = id ? decryptUrlData(id) : 0;
  const navigate = useNavigate();
  const componentId = componetData.projectComponentId;
  const projectId = componetData.projectId;
  // API'S Call
  const [updateProjectComponent, {
    isLoading: updateProjectComponentLoading,
    isSuccess: isSuccessUpdateProjectComponent,
    data: updateProjectComponentData,
  },] = useUpdateProjectComponentMutation();

  const [getProjectComponentById, {
    isFetching: isProjectComponentfetching,
    isSuccess: isProjectComponentsuccess,
    data: ProjectComponentData,
  },] = useLazyGetProjectComponentByIdQuery();
  
  //** useEffect's */
  useEffect(() => {
    formReset();
    if (componentId) {
      getProjectComponentById(componentId);
    }
  }, [componentId, getProjectComponentById]);

  useEffect(() => {
    if (isSuccessUpdateProjectComponent && updateProjectComponentData) {
      if (updateProjectComponentData.errorMessage.includes("exists")) {
        ToastService.warning(updateProjectComponentData.errorMessage);
        return;
      } else {
        ToastService.success(updateProjectComponentData.errorMessage);
        backToList();
      }
    }
  }, [isSuccessUpdateProjectComponent, updateProjectComponentData]);

  useEffect(() => {
    if (isProjectComponentsuccess && !isProjectComponentfetching && ProjectComponentData) {
      if (ProjectComponentData) {
        let Data = { ...formData };
        const { projectComponent } = ProjectComponentData;
        Data.initialState = {
          projectComponent,
        };
        setFormData(Data);
      }
    }
  }, [isProjectComponentsuccess, isProjectComponentfetching, ProjectComponentData,]);

  //** Funcation's */
  const handleProjectComponent = (e) => {
    e.preventDefault();
    const formData = ref.current.getFormData();
    if (componentId && formData) {
      const DataUpdate = {
        ...formData,
        projectComponent: formData.projectComponent,
        projectComponentId: componentId,
        projectId: projectId,
      };
      updateProjectComponent(DataUpdate);
    }
  };
  const formReset = () => {
    const projectForm = { ...projectComponentsFormData };
    projectForm.initialState = { ...projectComponentsFormData.initialState };
    setFormData(projectForm);
  };

  const backToList = () => {
    const currentPath = window.location.pathname;
    if (currentPath.includes('admin')) {
      navigate(`/admin/project/ProjectComponent/${encryptUrlData(projectId)}`);
    } else {
      navigate(`/myprojects/ProjectComponent/${encryptUrlData(projectId)}`);
    }
  };

  return (
    <div>
      <div className="project-module center-top-space edit-project-component">
        <CardSection
          isContentLoading={updateProjectComponentLoading || isProjectComponentfetching}
          cardTitle={"Edit Project Component"}
        >
          <form className="form-card row">
            <div className="pb-0 mb-0 col-8">
              <FormCreator config={formData} ref={ref} {...formData} />
            </div>
            <div className="col-4 mt-auto mb-2">
              <div className="form-btn d-flex justify-content-end">
                <Buttons
                  buttonTypeClassName="dark-btn"
                  onClick={backToList}
                  buttonText="Cancel"
                />
                <Buttons
                  buttonTypeClassName="theme-btn ml-4"
                  onClick={handleProjectComponent}
                  buttonText="Update"
                  imagePath={AppIcons.AddIcon}
                  isLoading={updateProjectComponentLoading}
                />
              </div>
            </div>
          </form>
        </CardSection>
        <div className="row">
          <div className="mt-1">
            <ProjectModuel />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProjectComponent;
